import { css } from 'styled-components/macro';

export const fonts = css`
  @font-face {
    font-family: "OpenSans";
    src: url("/fonts/OpenSans-Regular.ttf") format("truetype");
    font-display: swap;
  }
`;
